import styled from 'styled-components';

export const ResetPasswordForm = styled.form`
  flex: 1;
  > * {
    margin-right: 8px;

    &:last-child {
      margin-right: 0px;
    }
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 400px;
`;



// WEBPACK FOOTER //
// ./components/molecules/ResetPassword/layout.js